import { render, staticRenderFns } from "./SalaryEffectAdd.vue?vue&type=template&id=03116dc8&scoped=true&"
import script from "./SalaryEffectAdd.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03116dc8",
  null
  
)

export default component.exports